<template>
    <el-container class="config-page" v-wechat-title="$route.meta.title">
        <el-main>
            <div class="form-content">
                <div class="form-title column-header">
                    <span><i class="el-icon-s-tools"></i> 全局配置</span>
                    <el-button class="btn__style" v-if="isSuper == 1" @click="saveCofigParam">保存</el-button>
                </div>
                <el-form label-width="180px" :label-position="labelPosition">
                    <el-row>
                        <el-col :span="nodeWidth">
                            <el-form-item label="行情深度层数">
                                <el-input v-model="formData.depthMarket"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="nodeWidth">
                            <el-form-item label="滑点">
                                <el-input v-model="formData.priceSlippage"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="nodeWidth">
                            <el-form-item label="语音通知间隔时间">
                                <el-input v-model="formData.voiceIntervalTime"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="nodeWidth">
                            <el-form-item label="短信通知间隔时间">
                                <el-input v-model="formData.messageIntervalTime"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="nodeWidth">
                            <el-form-item label="交易间隔时间">
                                <el-input v-model="formData.tradingIntervalTime"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="nodeWidth">
                            <el-form-item label="是否允许借贷">
                                <el-switch v-model="formData.isBorrow"></el-switch>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-divider></el-divider>
                    <el-row>
                        <el-col :span="nodeWidth">
                            <el-form-item label="BTC允许借贷最大百分占比">
                                <el-input v-model="formData.maxBorrowBTC"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="nodeWidth">
                            <el-form-item label="LTC允许借贷最大百分占比">
                                <el-input v-model="formData.maxBorrowLTC"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="nodeWidth">
                            <el-form-item label="ETH允许借贷最大百分占比">
                                <el-input v-model="formData.maxBorrowETH"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="nodeWidth">
                            <el-form-item label="ETC允许借贷最大百分占比">
                                <el-input v-model="formData.maxBorrowETC"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="nodeWidth">
                            <el-form-item label="XRP允许借贷最大百分占比">
                                <el-input v-model="formData.maxBorrowXRP"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="nodeWidth">
                            <el-form-item label="EOS允许借贷最大百分占比">
                                <el-input v-model="formData.maxBorrowEOS"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="nodeWidth">
                            <el-form-item label="BCH允许借贷最大百分占比">
                                <el-input v-model="formData.maxBorrowBCH"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="nodeWidth">
                            <el-form-item label="BSV允许借贷最大百分占比">
                                <el-input v-model="formData.maxBorrowBSV"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="nodeWidth">
                            <el-form-item label="TRX允许借贷最大百分占比">
                                <el-input v-model="formData.maxBorrowTRX"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </el-main>
    </el-container>
</template>

<script>
/* eslint-disable */
import Header from '@/components/header/Header.vue'
import { get, put } from '@/api/index'
import { mapState } from 'vuex'

export default {
    components: {
        Header
    },
    data() {
        return {
            labelPosition: 'right',
            formData: {},
            isSuper: sessionStorage.getItem('isSuper'),
            nodeWidth: 12
        }
    },
    mounted() {
        this.isSuper = this.$cookies.get('isSuper');
        this.initConfigparam();
        this.getBrowserWidth()
        window.onresize = () => {
            this.getBrowserWidth()
        }
    },
    computed: {
        ...mapState([
            'token'
        ])
    },
    methods: {
        // 初始配置参数
        initConfigparam() {
            var url = this.$baseUrl + '/global/config/get';
            var param = {'token': this.token};
            get(url, param).then(resp => {
                if (resp.code == 200) {
                    this.formData = resp.data;
                } else {
                    this.$notify.error({
                        message: resp.info,
                        title: '提示',
                        offset: 100
                    })
                }
            })
        },

        // 保存配置参数
        saveCofigParam() {
            var url = this.$baseUrl + '/global/config/update';
            var param = this.formData;
            param['token'] = this.token;
            put(url, param).then(resp => {
                if (resp.code == 200) {
                    this.$notify.info({
                        message: '保存成功!',
                        title: '提示',
                        offset: 100
                    })
                } else {
                    this.$notify.error({
                        message: resp.info,
                        title: '提示',
                        offset: 100
                    })
                }
            })
        },

        // 屏幕width 计算
        getBrowserWidth() {
            var browserWidth = document.body.clientWidth;
            if (browserWidth < 900) {
                this.nodeWidth = 24;
            } else {
                this.nodeWidth = 12;
            }
        }
    }
}
</script>

<style lang="scss">
    .config-page{
        .el-main{
            // padding: 15px 0;
            background: #252425;
            .form-content{
                // padding: 10px;
                // box-shadow: 0 0 10 #000;
                .form-title{
                    margin: 0 auto;
                    background-color: #1e1e1e;
                    display: flex;
                    justify-content: space-between;
                    h3{
                        text-align: left;
                        color: #a8a7a9;
                    }
                }
                .el-form{
                    margin: 0 auto;
                    // margin-top: 30px;
                    color: #a8a7a9;
                    padding: 20px 10px;
                    background-color: #2A2D2E;
                    .el-divider{
                        margin: 0 0 15px 0;
                        background-color: #595a5a;
                    }
                    .el-row{
                        .el-col{
                            // margin-left: 30px;
                            padding: 3px 20px;
                            .el-form-item__label{
                                padding-right: 15px;
                                color: #a8a7a9;
                                font-size: 13px;
                            }
                            .el-input__inner{
                                background-color: #262829;
                                border-color: #262829;
                                color: #a8a7a9;
                                width: 80%;
                            }
                        }
                    }
                }
            }
        }
    }

    @media screen and (max-width: 1100px) {
        .config-page{
            .el-main{
                .form-content{
                    padding: 10px 0;
                    .form-title{
                        width: 100%;
                        padding: 10px 0;
                    }
                    .el-form{
                        width: 100%;
                        padding: 10px 0;
                        .el-form-item{
                            margin-bottom: 10px;
                        }
                    }
                }
            }
        }
    }

    @media screen and (max-width: 680px) {
        .config-page{
            .el-main{
                margin: 0 5px;
                .form-content{
                    padding: 10px 0;
                    .form-title{
                        width: 100%;
                        padding: 10px 0;
                    }
                    .el-form{
                        width: 100%;
                        padding: 10px 0;
                        .el-col{
                            padding: 3px 5px !important;
                            .el-form-item{
                                .el-form-item__label{
                                    font-size: 12px;
                                    width: 160px !important;
                                }
                                .el-form-item__content{
                                    margin-left: 160px !important;
                                    .el-input__inner{
                                        min-width: 150px;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</style>
